(() => {
  const hubs = document.querySelectorAll('[data-software-hub]');

  hubs.forEach((hub) => {
    const input = hub.querySelector('[data-software-search]');
    const filters = Array.from(hub.querySelectorAll('[data-software-filter]'));
    const cards = Array.from(hub.querySelectorAll('[data-software-card]'));
    const count = hub.querySelector('[data-software-count]');
    const empty = hub.querySelector('[data-software-empty]');
    const reset = hub.querySelector('[data-software-reset]');
    let activeFilter = 'all';

    const render = () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;

      cards.forEach((card) => {
        const matchesFilter = activeFilter === 'all' || card.dataset.categories.split(' ').includes(activeFilter);
        const matchesSearch = !query || card.dataset.search.includes(query);
        const show = matchesFilter && matchesSearch;
        card.hidden = !show;
        if (show) visible += 1;
      });

      count.textContent = `${visible} ${visible === 1 ? 'brand' : 'brands'}`;
      empty.hidden = visible !== 0;
    };

    input.addEventListener('input', render);

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.softwareFilter;
        filters.forEach((filter) => {
          const selected = filter === button;
          filter.classList.toggle('is-active', selected);
          filter.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        render();
      });
    });

    reset.addEventListener('click', () => {
      input.value = '';
      filters[0].click();
      input.focus();
    });
  });
})();
